import {
    Directive,
    ViewContainerRef,
    Type,
    Input,
    OnChanges,
    OnDestroy,
    ComponentRef,
    Output,
    EventEmitter,

    Injector
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { COMPONENT_MAP } from '../../DynamicComponentMap';
import { FlowComponent } from "../../flow/components/flow/flow.component";
import { State } from "../models/flow.dto";
import { ButtonLinkDataConfigComponent } from '../../builder/components/state/controls/config/data/button-link-data-config.component';
import { PaymentCheckoutDataConfigComponent } from "../../builder/components/state/controls/config/data/payment-checkout-data-config.component";
import { FileUploadComponent } from '../../form-controls/components/file-upload/file-upload.component';
import { SummaryComponent } from "../../form-controls/components/summary/summary.component";
import { ControllerFactory } from '../../form-controls/component-base/controller/controller.factory';
import { Controllable } from '../../form-controls/component-base/controller/controllable.interface';

@Directive({
    selector: '[dynamic-component-loader]',
    exportAs: 'componentLoaderRef',
    standalone: false
})
export class DynamicComponentLoaderDirective implements OnChanges, OnDestroy {
    componentRef: ComponentRef<any>;
    @Input() componentName: string;
    @Input() componentData: any;
    @Input() isEdit: boolean = false;
    @Input() componentContext: any;
    @Input() formGroup: FormGroup;
    @Input() flowComponent: FlowComponent;
    @Input() selectedState: State;
    @Input() componentInjector: Injector;

    @Output() save: EventEmitter<any> = new EventEmitter<any>();
    @Output() fileUploaded: EventEmitter<any> = new EventEmitter<any>();
    @Output() fileDeleted: EventEmitter<any> = new EventEmitter<any>();
    @Output() summaryLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        public injector: Injector,
        public _viewContainer: ViewContainerRef) { }

    public ngOnDestroy(): void {
        if (this.componentRef)
            this.componentRef.destroy();
    }

    public ngOnChanges(changes: any): void {
        if (this.componentRef) {
              this.componentRef.destroy();
        }          
        // Normalize the component name key
        const key = (this.componentName || '').replace(/component$/i, '').toLowerCase() + 'component';
        // Find the actual key in the map (case-insensitive)
        const mapKey = Object.keys(COMPONENT_MAP).find(k => k.toLowerCase() === key);

        const componentType = mapKey ? COMPONENT_MAP[mapKey] : undefined;

        if (!componentType) {
            console.error(`Unable to create component for key: ${this.componentName}`);
            throw new Error('Unable to create component');
        }
            

       this._viewContainer.clear();

        this.componentRef = this._viewContainer.createComponent(componentType, {
            injector: this.componentInjector || this.injector
        });

        this.componentRef.instance.formGroup = this.formGroup;
        this.componentRef.instance.componentContext = this.componentContext;
        this.componentRef.instance.componentData = this.componentData;
        this.componentRef.instance.isEdit = this.isEdit;
        this.componentRef.instance.flowComponent = this.flowComponent;
        this.componentRef.instance.saveMethod = this.save; //(side panel) <=> loader <=> component

        if (this.componentRef.instance instanceof ButtonLinkDataConfigComponent || this.componentRef.instance instanceof PaymentCheckoutDataConfigComponent)
            this.componentRef.instance.selectedState = this.selectedState;

        if (this.componentRef.instance instanceof FileUploadComponent) {
            this.componentRef.instance.fileUploaded = this.fileUploaded;
            this.componentRef.instance.fileDeleted = this.fileDeleted;
        }

        if (this.componentRef.instance instanceof SummaryComponent) {
            this.componentRef.instance.summaryLoaded = this.summaryLoaded;
        }
            

        //if form control is controllable then add a controller.
        if (this.componentRef.instance.controllers && this.componentRef.instance.controllers.length > 0 &&
            this.componentRef.instance.controllers[0].provide && this.componentRef.instance.controllers[0].useFactory) {
            let host: Controllable = <Controllable>this.componentRef.instance;
            let config = this.componentRef.instance.componentData.config;

            if (config) {
                let temp = ControllerFactory.createController(config.controller ?
                    config.controller.controllerName : null,
                    this.componentRef.injector, host.controllers);

                if (!config.controller)
                    config.controller = { controllerName: temp.controllerName };
                else
                    config.controller = { controllerName: temp.controllerName, arguments: config.controller.arguments };

                host.controller = temp.controller;
                host.controller.component = this.componentRef.instance;

                if (host.controller.setup)
                    host.controller.setup(config.controller.arguments);

                if (host.controller.onInit)
                    host.controller.onInit();

                this.componentRef.onDestroy(() => {
                    if (host.controller.onDestroy)
                        host.controller.onDestroy();
                });
            }
        }
    }
}